import { TypeBracketCodeEnum } from './TypeBracketCodeEnum';

export class TypeBracket {
  constructor(public readonly id: number, public readonly code: TypeBracketCodeEnum) {}
}
